import { Pipe, PipeTransform } from '@angular/core';

import { environment as ENV } from '@environment';

@Pipe({
  name: 'airlinePoliciesLink',
  standalone: false
})
export class AirlinePoliciesLinkPipe implements PipeTransform {

  constructor() { }

  transform(code: string): string {
    return code && ENV.countryModules?.airlines_local_policies_info[code] ?
      ENV.countryModules.airlines_local_policies_info[code] : null;
  }
}
